import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useUser } from '../../../contexts/userContext';
import { useCard } from '../../../contexts/cardContext'
import { useWhatsappZapi } from '../../../contexts/whatsappZapiContext';
import api from '../../../services/api';
import { FaBuilding, FaExclamationTriangle, FaLink, FaPlus, FaSearch, FaTimes, FaUserCheck } from 'react-icons/fa';
import { validateCardPhone } from '../../../utils/phoneValidation';

import './style.css';

// API URL for IBGE
const apiUrlIbge = 'https://servicodados.ibge.gov.br/api/v1/localidades';
const sanitizeCardName = (value) => String(value ?? '').replace(/\//g, '');

function CreateCard({ columnId, onClose }) {

  const { openModalCreateUser, user, listAllUsers } = useUser();

  const {
    cards,
    setCards,
    addHistoricoCardContext
  } = useCard();
  const {
    searchContacts,
    createContact,
    linkContactToCard,
    loadLinkedCards,
    searchCompanies,
    createCompany,
    getCompanyCards,
    getContactCompanies,
    linkCompanyToCard,
    linkCompanyToContact,
  } = useWhatsappZapi();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [fone, setFone] = useState('');
  const [error, setError] = useState('');
  const [isCreatingCard, setIsCreatingCard] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [pais, setPais] = useState('Brasil');
  const [cidadeEstadoInternacional, setCidadeEstadoInternacional] = useState('');
  const [whatsappContactMode, setWhatsappContactMode] = useState('none');
  const [whatsappContactSearch, setWhatsappContactSearch] = useState('');
  const [whatsappContactResults, setWhatsappContactResults] = useState([]);
  const [selectedWhatsappContact, setSelectedWhatsappContact] = useState(null);
  const [selectedWhatsappCards, setSelectedWhatsappCards] = useState([]);
  const [whatsappContactMessage, setWhatsappContactMessage] = useState('');
  const [companyMode, setCompanyMode] = useState('none');
  const [companySearch, setCompanySearch] = useState('');
  const [companyResults, setCompanyResults] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedCompanyCards, setSelectedCompanyCards] = useState([]);
  const [companyMessage, setCompanyMessage] = useState('');


  const [isPremium, setIsPremium] = useState(true); // Assumindo que o padrão seja 'true' até a verificação


  function getUserName(userId) {
    // Verifica se o userId é diferente do usuário atual
    if (userId === user.id) {
      return user.username; // Retorna o nome do usuário atual diretamente
    }

    //console.log(userId)
    const userFromList = listAllUsers.find(user => user.id === userId);
    return userFromList ? userFromList.username : 'Unknown';
  }

  useEffect(() => {
    axios.get(`${apiUrlIbge}/estados?orderBy=nome`).then(response => {
      const stateOptions = response.data.map(state => ({
        sigla: state.sigla,
        nome: state.nome,
      }));
      setStates(stateOptions);
    });
  }, []);

  useEffect(() => {
    if (state) {
      axios.get(`${apiUrlIbge}/estados/${state}/municipios?orderBy=nome`).then(response => {
        const cityOptions = response.data.map(city => ({
          id: city.id,
          nome: city.nome,
        }));
        setCities(cityOptions);
      });
    } else {
      setCities([]);
    }
  }, [state]);



  const getSelectedLocation = () => {
    const selectedState = states.find((st) => st.sigla === state);
    const selectedCity = cities.find((ct) => ct.id === parseInt(city));
    return {
      stateValue: pais === 'Brasil' ? (selectedState ? selectedState.sigla : state || selectedWhatsappContact?.state || '') : '',
      cityValue: pais === 'Brasil' ? (selectedCity ? selectedCity.nome : selectedWhatsappContact?.city || '') : cidadeEstadoInternacional,
    };
  };

  const fillCardWithContact = async (contact) => {
    setSelectedWhatsappContact(contact);
    setWhatsappContactMode('existing');
    setWhatsappContactResults([]);
    setWhatsappContactMessage('');

    if (!name && contact.name) setName(sanitizeCardName(contact.name));
    const contactPhone = contact.whatsapp_phone_display || contact.phone_display || contact.phone_normalized || '';
    if (!fone && contactPhone) setFone(contactPhone);
    if (!email && contact.email) setEmail(contact.email);
    if (contact.country) setPais(contact.country);
    if (contact.country === 'Brasil' && contact.state) setState(contact.state);
    if (contact.country && contact.country !== 'Brasil') {
      setCidadeEstadoInternacional([contact.city, contact.state].filter(Boolean).join(' - '));
    }

    try {
      if (contact.contact_id) {
        const cards = await loadLinkedCards(contact.contact_id);
        setSelectedWhatsappCards(cards || []);
      } else {
        setSelectedWhatsappCards([]);
      }
    } catch (error) {
      setSelectedWhatsappCards([]);
    }

    try {
      const companies = contact.contact_id ? await getContactCompanies(contact.contact_id) : [];
      if (companies && companies.length > 0) {
        await fillCardWithCompany({ ...companies[0], id: companies[0].company_id || companies[0].id });
        setCompanyMessage('Empresa sugerida a partir do contato.');
      }
    } catch (error) {
      // Empresa e opcional; falha aqui nao bloqueia a criacao do card.
    }
  };

  const clearWhatsappContact = () => {
    setSelectedWhatsappContact(null);
    setSelectedWhatsappCards([]);
    setWhatsappContactResults([]);
    setWhatsappContactMessage('');
  };

  const handleSearchWhatsappContacts = async () => {
    setWhatsappContactMessage('');
    const term = (whatsappContactSearch || fone || name || email || '').trim();
    if (!term) {
      setWhatsappContactMessage('Informe nome, telefone ou email para buscar.');
      return;
    }

    try {
      const results = await searchContacts(term);
      setWhatsappContactResults(results || []);
      setSelectedWhatsappContact(null);
      setSelectedWhatsappCards([]);
      if (!results || results.length === 0) {
        setWhatsappContactMessage('Nenhum contato encontrado.');
      }
    } catch (error) {
      setWhatsappContactMessage('Erro ao buscar contatos.');
    }
  };

  const fillCardWithCompany = async (company) => {
    const normalizedCompany = { ...company, id: company.company_id || company.id };
    setSelectedCompany(normalizedCompany);
    setCompanyMode('existing');
    setCompanyResults([]);
    setCompanyMessage('');

    if (!email && normalizedCompany.email) setEmail(normalizedCompany.email);
    if (!fone && normalizedCompany.phone) setFone(normalizedCompany.phone);
    if (normalizedCompany.country) setPais(normalizedCompany.country);
    if (normalizedCompany.country === 'Brasil' && normalizedCompany.state && !state) setState(normalizedCompany.state);
    if (normalizedCompany.country && normalizedCompany.country !== 'Brasil') {
      setCidadeEstadoInternacional([normalizedCompany.city, normalizedCompany.state].filter(Boolean).join(' - '));
    }

    try {
      const cards = await getCompanyCards(normalizedCompany.id);
      setSelectedCompanyCards(cards || []);
    } catch (error) {
      setSelectedCompanyCards([]);
    }
  };

  const clearCompany = () => {
    setSelectedCompany(null);
    setSelectedCompanyCards([]);
    setCompanyResults([]);
    setCompanyMessage('');
  };

  const handleSearchCompanies = async () => {
    setCompanyMessage('');
    const term = (companySearch || name || email || fone || '').trim();
    if (!term) {
      setCompanyMessage('Informe nome, CNPJ, telefone ou email para buscar.');
      return;
    }

    try {
      const results = await searchCompanies(term);
      setCompanyResults(results || []);
      setSelectedCompany(null);
      setSelectedCompanyCards([]);
      if (!results || results.length === 0) {
        setCompanyMessage('Nenhuma empresa encontrada.');
      }
    } catch (error) {
      setCompanyMessage('Erro ao buscar empresas.');
    }
  };

  const handleCreateCard = async (e) => {
    e.preventDefault();
    if (isCreatingCard) return;
    setIsCreatingCard(true);
    setError('');
    setWhatsappContactMessage('');

    const { stateValue, cityValue } = getSelectedLocation();
    const phoneError = validateCardPhone(fone, pais);
    if (phoneError) {
      setError(phoneError);
      setIsCreatingCard(false);
      return;
    }

    const cardData = {
      name,
      state: stateValue,
      city: cityValue,
      fone,
      email,
      column_id: columnId,
      entity_id: user.id,
      empresa_id: user.empresa_id,
      cidade_estado_internacional: pais !== 'Brasil' ? cidadeEstadoInternacional : '',
      pais: pais,
    };

    try {
      let contactToLink = selectedWhatsappContact;
      let companyToLink = selectedCompany;

      if (whatsappContactMode === 'existing' && !contactToLink) {
        setError('Selecione um contato WhatsApp ou escolha criar sem contato.');
        setIsCreatingCard(false);
        return;
      }

      if (whatsappContactMode === 'create') {
        if (!fone || !fone.trim()) {
          setError('Informe o telefone para criar o contato WhatsApp.');
          setIsCreatingCard(false);
          return;
        }

        contactToLink = await createContact({
          name,
          phone: fone,
          email,
          country: pais,
          state: stateValue,
          city: cityValue,
          source: 'card-create',
        });
      }

      if (companyMode === 'existing' && !companyToLink) {
        setError('Selecione uma empresa ou escolha continuar sem empresa.');
        setIsCreatingCard(false);
        return;
      }

      if (companyMode === 'create') {
        companyToLink = await createCompany({
          name: name || selectedWhatsappContact?.name || 'Empresa sem nome',
          trade_name: '',
          phone: fone,
          email,
          country: pais,
          state: stateValue,
          city: cityValue,
          source: 'card-create',
        });
      }

      // const response = await axios.post(`${apiUrl}/card/create`, cardData);
      const response = await api.post(`/card/create`, cardData);

      const createdCard = response.data;
      setCards([...cards, createdCard]); // Atualiza a lista de cards com o novo card

      addHistoricoCardContext(`Card criado por ${getUserName(parseInt(user.id))}.`, createdCard.card_id, user.id);

      if (whatsappContactMode !== 'none' && contactToLink) {
        try {
          await linkContactToCard(createdCard.card_id, contactToLink, true);
        } catch (linkError) {
          setIsCreatingCard(false);
          setError('Card criado, mas nao foi possivel vincular o contato WhatsApp.');
          return;
        }
      }

      if (companyMode !== 'none' && companyToLink) {
        try {
          await linkCompanyToCard(createdCard.card_id, companyToLink.id || companyToLink.company_id, true);
          if (contactToLink) {
            await linkCompanyToContact(companyToLink.id || companyToLink.company_id, contactToLink.id || contactToLink.contact_id, true);
          }
        } catch (linkCompanyError) {
          setIsCreatingCard(false);
          setError('Card criado, mas nao foi possivel vincular a empresa.');
          return;
        }
      }

      //console.log(      getUserName(user.id), createdCard.card_id, user.id) 



      openModalCreateUser();
      onClose();
    } catch (error) {
      setIsCreatingCard(false);
      setError(
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Erro ao criar Card.',
      );
    }
  };





  return (
    <div className='create-card-modal'>
      <div className='create-card-container'>
        <div className='header-update-card-container'>
          <label>Criar Oportunidade</label>
        </div>
        <div className="create-card-form-container">
          <form className="create-card-form" onSubmit={handleCreateCard}>
            <section className="create-card-zapi-contact-box create-card-zapi-contact-box--first">
              <div className="create-card-zapi-smart-header">
                <span>1</span>
                <div>
                  <strong>Contato</strong>
                  <small>Busque o contato antes de criar para evitar duplicidade e puxar os dados automaticamente.</small>
                </div>
              </div>

              <div className="create-card-zapi-search-row create-card-zapi-search-row--hero">
                <input
                  value={whatsappContactSearch}
                  onChange={(e) => setWhatsappContactSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleSearchWhatsappContacts();
                    }
                  }}
                  placeholder="Buscar por nome, telefone, email ou documento"
                />
                <button type="button" onClick={handleSearchWhatsappContacts} title="Buscar contato"><FaSearch /> Buscar</button>
              </div>

              {selectedWhatsappContact && (
                <div className="create-card-zapi-selected create-card-zapi-selected--hero">
                  <FaUserCheck />
                  <div>
                    <strong>{selectedWhatsappContact.name || selectedWhatsappContact.whatsapp_phone_display || selectedWhatsappContact.phone_display || selectedWhatsappContact.phone_normalized}</strong>
                    <span>{selectedWhatsappContact.whatsapp_phone_display || selectedWhatsappContact.phone_display || selectedWhatsappContact.phone_normalized}</span>
                    {selectedWhatsappContact.email && <small>{selectedWhatsappContact.email}</small>}
                  </div>
                  <button type="button" onClick={clearWhatsappContact} title="Remover contato"><FaTimes /></button>
                </div>
              )}

              {selectedWhatsappCards.length > 0 && (
                <div className="create-card-zapi-duplicate-alert">
                  <FaExclamationTriangle />
                  <div>
                    <strong>Este contato ja tem {selectedWhatsappCards.length} card{selectedWhatsappCards.length > 1 ? 's' : ''} vinculado{selectedWhatsappCards.length > 1 ? 's' : ''}.</strong>
                    {selectedWhatsappCards.slice(0, 3).map((card) => (
                      <span key={card.card_id}>{card.name || `Card ${card.card_id}`} {card.column_name ? `- ${card.column_name}` : ''}</span>
                    ))}
                  </div>
                </div>
              )}

              {!selectedWhatsappContact && whatsappContactResults.length > 0 && (
                <div className="create-card-zapi-results create-card-zapi-results--hero">
                  {whatsappContactResults.map((contact) => (
                    <button type="button" key={contact.contact_id || `participante-${contact.participante_id || contact.id}`} onClick={() => fillCardWithContact(contact)}>
                      <FaLink />
                      <span>{contact.name || contact.whatsapp_phone_display || contact.phone_display || contact.phone_normalized}</span>
                      <small>{contact.whatsapp_phone_display || contact.phone_display || contact.phone_normalized}</small>
                    </button>
                  ))}
                </div>
              )}

              <div className="create-card-zapi-choice-row">
                <button type="button" className={whatsappContactMode === 'create' ? 'create-card-zapi-choice-active' : ''} onClick={() => { setWhatsappContactMode('create'); clearWhatsappContact(); }}>
                  <FaPlus />
                  <span>Criar contato ao salvar</span>
                  <small>Usa nome, fone, email e cidade abaixo</small>
                </button>
                <button type="button" className={whatsappContactMode === 'none' ? 'create-card-zapi-choice-active' : ''} onClick={() => { setWhatsappContactMode('none'); clearWhatsappContact(); }}>
                  <FaTimes />
                  <span>Continuar sem contato</span>
                  <small>Cria apenas o card</small>
                </button>
              </div>

              {whatsappContactMode === 'create' && (
                <div className="create-card-zapi-create-note">
                  <FaPlus />
                  <span>{fone ? `Novo contato sera criado/atualizado com o telefone ${fone}.` : 'Informe o telefone nos dados da oportunidade para criar o contato.'}</span>
                </div>
              )}

              {whatsappContactMessage && <span className="create-card-zapi-message">{whatsappContactMessage}</span>}
            </section>

            {false && (
            <>
            <div className="create-card-zapi-section-title">
              <span>2</span>
              <strong>Empresa opcional</strong>
            </div>

            <section className="create-card-zapi-company-box">
              <div className="create-card-zapi-search-row create-card-zapi-search-row--hero">
                <input
                  value={companySearch}
                  onChange={(e) => setCompanySearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleSearchCompanies();
                    }
                  }}
                  placeholder="Buscar empresa por nome, CNPJ, telefone ou email"
                />
                <button type="button" onClick={handleSearchCompanies} title="Buscar empresa"><FaSearch /> Buscar</button>
              </div>

              {selectedCompany && (
                <div className="create-card-zapi-selected create-card-zapi-selected--hero">
                  <FaBuilding />
                  <div>
                    <strong>{selectedCompany.name || selectedCompany.trade_name}</strong>
                    <span>{[selectedCompany.city, selectedCompany.state].filter(Boolean).join('/') || selectedCompany.document_number || 'Empresa selecionada'}</span>
                    {selectedCompany.email && <small>{selectedCompany.email}</small>}
                  </div>
                  <button type="button" onClick={clearCompany} title="Remover empresa"><FaTimes /></button>
                </div>
              )}

              {selectedCompanyCards.length > 0 && (
                <div className="create-card-zapi-duplicate-alert">
                  <FaExclamationTriangle />
                  <div>
                    <strong>Esta empresa ja tem {selectedCompanyCards.length} card{selectedCompanyCards.length > 1 ? 's' : ''} vinculado{selectedCompanyCards.length > 1 ? 's' : ''}.</strong>
                    {selectedCompanyCards.slice(0, 3).map((card) => (
                      <span key={card.card_id}>{card.name || `Card ${card.card_id}`} {card.column_name ? `- ${card.column_name}` : ''}</span>
                    ))}
                  </div>
                </div>
              )}

              {!selectedCompany && companyResults.length > 0 && (
                <div className="create-card-zapi-results create-card-zapi-results--hero">
                  {companyResults.map((company) => (
                    <button type="button" key={company.id} onClick={() => fillCardWithCompany(company)}>
                      <FaBuilding />
                      <span>{company.name || company.trade_name}</span>
                      <small>{company.document_number || [company.city, company.state].filter(Boolean).join('/') || company.phone}</small>
                    </button>
                  ))}
                </div>
              )}

              <div className="create-card-zapi-choice-row">
                <button type="button" className={companyMode === 'create' ? 'create-card-zapi-choice-active' : ''} onClick={() => { setCompanyMode('create'); clearCompany(); }}>
                  <FaPlus />
                  <span>Criar empresa ao salvar</span>
                  <small>Usa os dados abaixo como base</small>
                </button>
                <button type="button" className={companyMode === 'none' ? 'create-card-zapi-choice-active' : ''} onClick={() => { setCompanyMode('none'); clearCompany(); }}>
                  <FaTimes />
                  <span>Continuar sem empresa</span>
                  <small>Empresa fica em branco</small>
                </button>
              </div>

              {companyMode === 'create' && (
                <div className="create-card-zapi-create-note">
                  <FaPlus />
                  <span>{name ? `Empresa sera criada/atualizada como ${name}.` : 'Informe o nome da oportunidade ou busque uma empresa existente.'}</span>
                </div>
              )}

              {companyMessage && <span className="create-card-zapi-message">{companyMessage}</span>}
            </section>
            </>
            )}

            <div className="create-card-zapi-section-title">
              <span>2</span>
              <strong>Dados da oportunidade</strong>
            </div>

            <label htmlFor="username" className='create-card-label-input'>Nome:</label>
            <input id="username" className="create-card-input" type="text" value={name} onChange={(e) => setName(sanitizeCardName(e.target.value))} />

            <label htmlFor="city-state" className='create-card-label-input'>País:</label>
            <div className='select-cidade-estado-container'>
              <select id="pais" className="select-estado-cidade" value={pais} onChange={(e) => setPais(e.target.value)}>
                <option value="Brasil">Brasil</option>
                <option value="Paraguai">Paraguai</option>
              </select>
            </div>

            {pais === 'Brasil' ? (
              <>
                <label htmlFor="city-state" className='create-card-label-input'>Cidade / Estado:</label>
                <div className='select-cidade-estado-container'>
                  <select id="state" className="select-estado-cidade" value={state} onChange={(e) => setState(e.target.value)}>
                    <option value="">Selecione o estado</option>
                    {states.map(state => (
                      <option key={state.sigla} value={state.sigla}>{state.nome}</option>
                    ))}
                  </select>

                  <select id="city" className="select-estado-cidade" value={city} onChange={(e) => setCity(e.target.value)} disabled={!state}>
                    <option value="">Selecione a cidade</option>
                    {cities.map(city => (
                      <option key={city.id} value={city.id}>{city.nome}</option>
                    ))}
                  </select>
                </div>
              </>
            ) : (
              <>
                <label htmlFor="cidadeEstadoInternacional" className='create-card-label-input'>Cidade / Estado:</label>
                <input id="cidadeEstadoInternacional" className="create-card-input" type="text" placeholder="Ex: Ciudad del Este - Alto Paraná" value={cidadeEstadoInternacional} onChange={(e) => setCidadeEstadoInternacional(e.target.value)} />
              </>
            )}

            <label htmlFor="fone" className='create-card-label-input'>Fone:</label>
            <input id="fone" className="create-user-input" type="tel" inputMode="tel" value={fone} onChange={(e) => setFone(e.target.value)} />

            <label htmlFor="email" className='create-card-label-input'>Email:</label>
            <input id="email" className="create-user-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

            <label className='create-card-label-input'>Column ID: {columnId}</label>
          </form>
        </div>
        {error && <div className="create-card-error-message">{error}</div>}

        <div className='create-card-footer'>
          <button className="create-card-close-button" onClick={onClose}>Cancelar</button>
          <button type="submit" className="create-card-button" onClick={handleCreateCard} disabled={isCreatingCard}>Criar Card</button>
        </div>
      </div>
    </div>
  );
}

export default CreateCard;
